export default (props) => {
  const { ixDependency, code, assetName, name, argsAmount } = props;
  return `
/** pragma type script **/

import {
  getEnvironment,
  replaceImportAddresses,
  reportMissingImports,
  reportMissing,
  executeScript
} from '${ixDependency}'

export const CODE = \`
${code}
\`;

/**
 * Method to generate cadence code for ${assetName} script
 * @param {Object.<string, string>} addressMap - contract name as a key and address where it's deployed as value
 */
export const ${assetName}Template = async (addressMap = {}) => {
  const envMap = await getEnvironment();
  const fullMap = {
    ...envMap,
    ...addressMap,
  };

  // If there are any missing imports in fullMap it will be reported via console
  reportMissingImports(CODE, fullMap, \`${name} =>\`)

  return replaceImportAddresses(CODE, fullMap);
};

export const ${assetName} = async (props = {}) => {
  const { addressMap = {}, args = [] } = props
  const code = await ${assetName}Template(addressMap);

  reportMissing("arguments", args.length, ${argsAmount}, \`${name} =>\`);

  return executeScript({code, processed: true, ...props})
}  
  `;
};
